import { CircularProgress, makeStyles } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useRef, useState } from 'react';
import { Controller } from 'react-hook-form';
import { useNetwork } from 'services/network';
import { theme } from 'theme';
import { useDebounce } from 'utils/hooks';
import CustomTextFieldComponent from './CustomTextFieldComponent';

const useStyles = makeStyles({
  input: {
    '& .MuiInputBase-root.MuiOutlinedInput-root.MuiAutocomplete-inputRoot': {
      height: '40px',
      paddingTop: 0,
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.colors.primary.red,
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: theme.colors.primary.red,
    },
    '& .MuiChip-root': {
      height: '25px !important',
    },
  },
});

const RHFApiAutocomplete = ({
  name,
  control,
  rules,
  label,
  placeholder,
  charactersCount = 3,
  endpoint,
  endpointEntity = 'name',
  inputList = [],
  freeSolo,
  disabled = false,
  multiple = false,
  defaultValue,
}) => {
  const subRef = useRef(null);
  const classes = useStyles();
  const [options, setOptions] = useState([]);
  const [characters, setCharacters] = useState('');
  const [loading, setLoading] = useState(false);
  const debouncedText = useDebounce(characters, 500);
  const network = useNetwork();

  useEffect(() => {
    if (debouncedText && debouncedText.length >= charactersCount && endpoint) {
      setLoading(true);
      network
        .get(
          `${endpoint}?filter[${endpointEntity}][value]=${characters}&filter[${endpointEntity}][operator]=CONTAINS`
        )
        .then((res) => {
          const data = res?.data?.data?.length
            ? res.data.data.map((o) => ({
                value: o.id,
                label: o.attributes.name,
              }))
            : [];
          setOptions(data);
          setLoading(false);
        });
    }
    if (
      debouncedText &&
      debouncedText !== '' &&
      debouncedText.length >= charactersCount &&
      inputList.length
    ) {
      setOptions(inputList);
    } else {
      setOptions([]);
    }
  }, [debouncedText]);

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={(props) => {
        return (
          <Autocomplete
            {...props}
            id={`${name}_id`}
            ref={subRef}
            loadingText={options.length === 0 ? 'Loading...' : ''}
            options={options}
            getOptionLabel={(option) =>
              typeof option === 'string' ? option : option.label || ''
            }
            className={classes.input}
            disabled={disabled}
            onChange={(_event, value) => props.onChange(value)}
            onInputChange={(_event, value) => setCharacters(value)}
            freeSolo={freeSolo}
            multiple={multiple}
            renderInput={(params) => {
              return (
                <CustomTextFieldComponent
                  {...(freeSolo && {
                    onChange: props.onChange,
                  })}
                  autoComplete={'off'}
                  {...params}
                  label={label}
                  inputRef={subRef}
                  placeholder={placeholder}
                  variant="outlined"
                  value={props.value}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loading ? (
                          <CircularProgress color={'inherit'} size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              );
            }}
          />
        );
      }}
    />
  );
};

export default RHFApiAutocomplete;
